import { createFileRoute } from '@tanstack/react-router';

import { ShareLinkFormPage } from '../features/sharing/share-link-form-page';

export const Route = createFileRoute(
  '/manage/$companySlug/projects/$projectId/presentations/$presentationId/shares/new',
)({ component: NewShareLinkRoute });

function NewShareLinkRoute() {
  return <ShareLinkFormPage {...Route.useParams()} />;
}
